import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormFields } from '../../AccountForm.meta';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';

export const AnnuitySurrenderSchedule = () => {
  const { register } = useFormContext<FormFields>();

  return (
    <Input
      {...register('bankAccount.AnnuitySurrenderSchedule')}
      label="Surrender Schedule"
      tooltip="'Enter the Surrender Schedule starting from the first contract year in the following comma separated format: 15%, 15%, 15%, 15%, 12.86%, 10.71%, 8.57%, 6.43%, 4.29%, 2.14%. In this example, there is a 15% surrender charge applied during the first year of the annuity based on the Purchase Year field.'"
    />
  );
};
